import { CustomElement } from '@/utils';
import { go } from '@/barba';
import Pagination from '@/components/Pagination';
import Calendar from '@/components/Calendar';
import select from 'dom-select';
import htmx from 'htmx.org';

export default class Filters extends CustomElement {
  static component = 'b-filters';
  checkboxes: HTMLInputElement[] = [];
  pagination: Pagination;
  removes: HTMLButtonElement[] = [];
  filters: HTMLButtonElement[] = [];
  filterCalendar: Calendar;

  init() {
    this.checkboxes = this.$$('checkbox');
    this.filterCalendar = this.$('filter-calendar');

    this.setChecks();
    this.setFilterButtons();

    this.checkboxes.forEach((ch) => {
      ch.addEventListener('change', () => {
        this.checkboxes.forEach((ch2) => {
          if (ch2.name === ch.name && ch.value !== ch2.value) {
            ch2.checked = false;
          }
        });

        this.setFilter(ch.name, ch.value, ch.checked);
      });
    });

    this.filterCalendar?.addEventListener('b-change', (e: CustomEvent) => {
      const date = e.detail as Date[];
      if (date.length) {
        const year = date[0].getFullYear();
        const month = String(date[0].getMonth() + 1).padStart(2, '0');  // Months are zero-indexed
        const day = String(date[0].getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        this.setFilter('start-date', formattedDate, true);
      }
    });

    requestAnimationFrame(() => {
      this.pagination = document.querySelector('b-pagination');
    })
  }

  setChecks() {
    const params = new URLSearchParams(window.location.search);
    this.checkboxes.forEach((ch) => {
      ch.checked = params.has(ch.name) && params.get(ch.name) === ch.value;
    })
  }

  setFilterButtons() {
    select.all('[data-el="filter"]').forEach((f) => {
      f.addEventListener('click', () => {
        if (f.hasAttribute('data-filter-key')) {
          const key = f.getAttribute('data-filter-key');
          const value = f.getAttribute('data-filter-value');
          this.setFilter(key, value, true);
        }
      });
    });

    select.all('[data-el="filter-remove"]').forEach((r) => {
      r.addEventListener('click', () => {
        if (r.hasAttribute('data-filter-key')) {
          const key = r.getAttribute('data-filter-key');
          this.setFilter(key, '', false);
        }
      });
    });
  }

  setFilter(name: string, value: string, add = true) {
    const params = new URLSearchParams(window.location.search);
    if (add) {
      params.set(name, value);
    } else {
      params.delete(name);
    }

    if (this.pagination) {
      window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
      this.pagination.loadPage('1').then(() => {
        this.setFilterButtons();
        this.setChecks();
      });
    } else {
      go({ url: `${window.location.pathname.replace(/\/$/, '')}?${params.toString()}` })
    }
  }
}
